export default __webpack_public_path__ + "static/media/icon.97e7e5ad.png";